import React, { createContext, useReducer } from 'react';
import axios from '../../../../../../api/axios';

export const CategoryContext = createContext(null);
const initialState = {
  inProgress: false,
  category: null,
  categories: null,
  selected: null,
};
function reducer(state, actions) {
  const { payload, type } = actions;
  switch (type) {
    case 'PROGRESS':
      return { ...state, inProgress: payload };
    case 'CHANGE':
      return { ...state, [payload.name]: payload.value };
    case 'CATEGORIES':
      return { ...state, categories: payload };
    case 'ADD_CATEGORY':
      return {
        ...state,
        category: '',
        categories: [payload, ...state.categories],
      };
    case 'SELECT_CATEGORY':
      return {
        ...state,
        selected: payload,
        category: payload.name,
      };
    case 'RESET_FORM':
      return { ...initialState, categories: state.categories };
    default:
      return state;
  }
}

const CategoryProvider = ({ children, showMessage, showError }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const addCategory = async (catName) => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const { data } = await axios.post(`/api/v1/admin/rules/categories/`, {
        name: catName,
      });
      data?.ok && showMessage(data?.messages);
      //   loadCategories();
      dispatch({ type: 'ADD_CATEGORY', payload: data.category });
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };
  const editCategory = async (catName, catId) => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const { data } = await axios.put(
        `/api/v1/admin/rules/categories/${catId}`,
        {
          name: catName,
        }
      );
      data?.ok && showMessage(data?.messages);
      loadCategories();
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };
  const deleteCategory = async (catId) => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const { data } = await axios.delete(
        `/api/v1/admin/rules/categories/${catId}`
      );
      data?.ok && showMessage(data.messages);
      loadCategories();
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };
  const changeTextField = (e) => {
    const { name, value } = e.target;
    dispatch({ type: 'CHANGE', payload: { name, value } });
  };
  const loadCategories = async () => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const { data } = await axios.get(`/api/v1/admin/rules/categories/all`);
      data?.ok && dispatch({ type: 'CATEGORIES', payload: data.categories });
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };
  const selectCategory = (category) => {
    dispatch({ type: 'SELECT_CATEGORY', payload: category });
  };
  const resetForm = () => {
    dispatch({ type: 'RESET_FORM' });
  };

  return (
    <CategoryContext.Provider
      value={{
        ...state,
        addCategory,
        editCategory,
        selectCategory,
        resetForm,
        deleteCategory,
        changeTextField,
        loadCategories,
        showMessage,
        showError,
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
};

export default React.memo(CategoryProvider);
